module.exports = __webpack_public_path__ + "img/find-my-friend-active.4515093d.svg";